import { HStack } from '@chakra-ui/react';
import {
  FilterNumberInput,
  FilterDateInput,
  FilterTextInput,
} from '../../../../../../sheet/components/grid/filterDropdown/filterAtoms/ConditionFilterInputs';
import {
  isTextlessFilter,
  isNumberRangeInputFilter,
  isDateRangeInputFilter,
  isDateInputFilter,
  isTextInputFilter,
} from '../../../../../../sheet/utils/filter/filterCondition';
import { UpdateRule } from '../useCreateDataValidation';
import {
  DateValidation,
  NumberValidation,
  TextLengthValidation,
  TextValidation,
} from '../../../../../../sheet/types';

interface RuleConditionInputsProps {
  rule:
    | NumberValidation
    | TextValidation
    | TextLengthValidation
    | DateValidation;
  updateRule: UpdateRule;
}
const RuleConditionInputs = ({
  rule,
  updateRule,
}: RuleConditionInputsProps) => {
  const { condition, firstValue = '', secondValue = '' } = rule;

  const changeValue = (key: string, value: string) => {
    updateRule({
      [key]: value,
    });
  };

  const firstValueProps = {
    title: 'firstValue',
    value: firstValue,
    isInvalid: false, //!!errors.firsValue,
    changeValue,
  };
  const secondValueProps = {
    title: 'secondValue',
    value: secondValue,
    isInvalid: false, // !!errors.secon,
    changeValue,
  };

  const renderInputsView = () => {
    switch (true) {
      case isTextlessFilter(condition):
        return null;
      case isNumberRangeInputFilter(condition):
        return (
          <HStack>
            <FilterNumberInput {...firstValueProps} />
            <FilterNumberInput {...secondValueProps} />
          </HStack>
        );
      case isDateRangeInputFilter(condition):
        return (
          <HStack>
            <FilterDateInput {...firstValueProps} />
            <FilterDateInput {...secondValueProps} />
          </HStack>
        );
      case isDateInputFilter(condition):
        return <FilterDateInput {...firstValueProps} />;
      case isTextInputFilter(condition):
        return <FilterTextInput {...firstValueProps} />;
      default:
        return <FilterNumberInput {...firstValueProps} />;
    }
  };

  return renderInputsView();
};

export default RuleConditionInputs;
